<div class="no-video-blk">
  <img class="video-not-found" src="assets/images/no-videos.svg" alt="no-videos" />
  <h4>{{ data }}</h4>
</div>
